export function safeParseJson<T extends object>(json: string): T {
  if (json === '' || json === null || json === undefined) {
    return {} as T;
  }

  try {
    return JSON.parse(json);
  } catch (error) {
    return {} as T;
  }
}
